"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SummaryTile = exports.tasksPerCompletionState = void 0;
const React = __importStar(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const theme_1 = __importDefault(require("../../components/styles/theme"));
const Pad_1 = require("../../components/styles/Pad");
const Heading_1 = require("../../components/heading/Heading");
const IconTextSpan_1 = require("../../components/icon-text-span/IconTextSpan");
const Spacer_1 = require("../../components/spacer/Spacer");
const merlin_tile_1 = require("@travelnest/merlin.tile");
const types_1 = require("../../../entities/fact/types");
const _1_svg_1 = __importDefault(require("../../../71eb904/assets/images/tiles/1.svg"));
const StyleWrapper = styled_1.default.div `
	.summary-item {
		${theme_1.default.typography.b1}
		padding-bottom: 10px;
	}
`;
const TextOverflow = styled_1.default.span `
	display: block;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
`;
const tasksPerCompletionState = (taskCompleteness) => {
    const complete = [];
    const needReview = [];
    const needInput = [];
    Object.entries(taskCompleteness).forEach(c => {
        switch (c[1].completion) {
            case types_1.TaskCompletionState.COMPLETE:
                complete.push(c[0]);
                break;
            case types_1.TaskCompletionState.INPUT_REQUIRED:
                needInput.push(c[0]);
                break;
            case types_1.TaskCompletionState.REVIEW_REQUIRED:
                needReview.push(c[0]);
                break;
            default:
                break;
        }
    });
    return { complete, needReview, needInput };
};
exports.tasksPerCompletionState = tasksPerCompletionState;
const SummaryTile = (props) => {
    const { property, imageUrl, completion: { complete, needReview, needInput } } = props;
    const title = (property === null || property === void 0 ? void 0 : property.internal_name) || (property === null || property === void 0 ? void 0 : property.name) || 'Travelnest Property';
    const image = imageUrl || _1_svg_1.default;
    const completeSummary = (complete.length === 1) ? `${complete.length} section is complete` : `${complete.length} sections are complete`;
    const reviewSummary = (needReview.length === 1) ? `${needReview.length} section requires review` : `${needReview.length} sections require review`;
    const inputSummary = (needInput.length === 1) ? `${needInput.length} section requires input` : `${needInput.length} sections require input`;
    return React.createElement("div", { className: "tbp-property-dashboard__tile" },
        React.createElement(merlin_tile_1.Tile, { imageUrl: image, imageSize: "100% 100%", imageBgColour: "#fffde9" },
            React.createElement(Pad_1.Pad, null,
                React.createElement(Heading_1.Heading, { "data-testid": "summary-heading" },
                    React.createElement(TextOverflow, { title: title }, title)),
                React.createElement(Spacer_1.Spacer, null),
                React.createElement(StyleWrapper, null,
                    React.createElement("div", { className: "summary-item", "data-testid": "complete-summary" },
                        React.createElement(IconTextSpan_1.IconTextSpan, { icon: "check", display: "success", text: completeSummary })),
                    React.createElement("div", { className: "summary-item", "data-testid": "review-summary" },
                        React.createElement(IconTextSpan_1.IconTextSpan, { icon: "ellipses", display: "primary", text: reviewSummary })),
                    React.createElement("div", { className: "summary-item", "data-testid": "input-summary" },
                        React.createElement(IconTextSpan_1.IconTextSpan, { icon: "exclamation", display: "error", text: inputSummary }))))));
};
exports.SummaryTile = SummaryTile;
//# sourceMappingURL=SummaryTile.js.map